export const categories = [
  {
    logo: "/categories/life.jfif",
    name: "Philosophies",
    topics: "11",
    link: "/wiki/philosophies",
    article1_logo: "/images/stoicism.jfif",
    article1_title: "Stoicism",
    article1_link: "stoicism",
    article2_logo: "/images/nihilism.jfif",
    article2_title: "Nihilism",
    article2_link: "nihilism",
  },
  {
    logo: "/categories/biotehnology.jfif",
    name: "Biotehnology",
    topics: "3",
    link: "/wiki/biotechnology",
    article1_logo: "/images/dna.jpg",
    article1_title: "DNA",
    article1_link: "dna",
    article2_logo: "/images/genetics.jpg",
    article2_title: "Genetics",
    article2_link: "genetics",
  },
  {
    logo: "/categories/cryptocurrency.png",
    name: "Blockchain and cryptocurrency",
    topics: "12",
    link: "/wiki/blockchain-and-cryptocurrency",
    article1_logo: "/categories/bitcoin.png",
    article1_title: "Bitcoin",
    article1_link: "bitcoin",
    article2_logo: "/images/smart-contracts.png",
    article2_title: "Smart Contracts",
    article2_link: "smart-contracts",
  },
  {
    logo: "/categories/quantum-computing.png",
    name: "Quantum Computing",
    topics: "0",
    link: "#",
    article1_logo: "",
    article1_title: "",
    article1_link: "#",
    article2_logo: "",
    article2_title: "",
    article2_link: "#",
  },
];
